import React, { useState } from 'react';
import styles from './profilebody.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import AddVendorBilling from '../addEditAddress/AddVendorBilling';
import EditVendorBilling from '../addEditAddress/EditVendorBilling';
import EditVendorShipping from '../addEditAddress/EditVendorShipping';
import AddVendorShipping from '../addEditAddress/AddVendorShipping';

const VendorProfileBody = () => {

    const { id } = useParams()
    const [isAddPopupOpen, setAddPopupOpen] = useState(false);
    const [isEditPopupOpen, setEditPopupOpen] = useState(false);
    const [isAddShipPopupOpen, setAddShipPopupOpen] = useState(false);
    const [isEditShipPopupOpen, setEditShipPopupOpen] = useState(false);

    const openAddPopup = () => {
        setAddPopupOpen(true);
    };

    const closeAddPopup = () => {
        setAddPopupOpen(false);
    };

    const openEditPopup = () => {
        setEditPopupOpen(true);
    };

    const closeEditPopup = () => {
        setEditPopupOpen(false);
    };
    
    const openAddShipPopup = () => {
        setAddShipPopupOpen(true);
    };

    const closeAddShipPopup = () => {
        setAddShipPopupOpen(false);
    };
    
    const openEditShipPopup = () => {
        setEditShipPopupOpen(true);
    };

    const closeEditShipPopup = () => {
        setEditShipPopupOpen(false);
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: "20px", width: "100%" }}>
                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Account Settings</h2>
                        {/* <button className={styles.editButton} onClick={handleEdit} >
                {isEditing ? 'Save' : 'Edit profile'}
                Edit profile
                 </button> */}
                    </div>
                    <div className={styles.profilebodyContent}>
                        <div className={styles.profilebodyDetails}>
                            <label htmlFor="fullName">Full Name</label>
                            <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                value="Dianne"
                            />

                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value="dianne.russell@gmail.com"
                            />

                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value="(603) 555-0123"
                            />

                            <label htmlFor="fullName">Company</label>
                            <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                value="xyz"
                            />

                            <label htmlFor="phone">GST</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value="555-0123"
                            />
                            <button className={styles.savechanges}>Save Changes</button>
                        </div>
                    </div>
                </div>

                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Change Password</h2>
                    </div>

                    <div className={styles.profilebodyContent}>
                        <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                            <label className={styles.addCatLabel} style={{ width: '100%' }}>
                                Current Password
                                <div className={styles.logininputContainer}>
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="********"
                                    /*  className={styles.addCatInput} */
                                    />
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        className={styles.loginpasswordIcon}
                                    />
                                </div>
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    New Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="password"
                                            name="password"
                                            placeholder="********"
                                        /*  className={styles.addCatInput} */
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="password"
                                            name="password"
                                            placeholder="********"
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                </label>
                            </div>
                            <button className={styles.savechanges}>Change Password</button>

                        </div>
                    </div>
                </div>


                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Billing Address</h2>
                        <button className={styles.savechanges} onClick={openAddPopup}>Add New Addres</button>
                        {isAddPopupOpen && <AddVendorBilling onClose={closeAddPopup} id={id} />}
                    </div>
                    <div className={styles.profilebodyContent}>
                        <div className={styles.address_container}>
                            <div className={styles.address_box}>
                                <div className={styles.h3}>Billing Address</div>
                                <div className={styles.address_deets}>
                                    <p><strong>Dainne Russell</strong></p>
                                    <p>4140 Parker Rd. Allentown, New Mexico 31134</p>
                                    <p><strong>Email:</strong> dainne.russell@gmail.com</p>
                                    <p><strong>Phone:</strong> (671) 555-0110</p>
                                </div>
                                <button className={styles.editbtn} onClick={openEditPopup}>Edit Address</button>
                                {isEditPopupOpen && <EditVendorBilling onClose={closeEditPopup} id={id} />}
                            </div>
                            <div className={styles.address_box}>
                                <div className={styles.h3}>Billing Address</div>
                                <div className={styles.address_deets}>
                                    <p><strong>Dainne Russell</strong></p>
                                    <p>4140 Parker Rd. Allentown, New Mexico 31134</p>
                                    <p><strong>Email:</strong> dainne.russell@gmail.com</p>
                                    <p><strong>Phone:</strong> (671) 555_0110</p>
                                </div>
                                <button className={styles.editbtn} onClick={openEditPopup}>Edit Address</button>
                                {isEditPopupOpen && <EditVendorShipping onClose={closeEditPopup} id={id} />}
                            </div>
                        </div>
                    </div>

                </div>


                <div className={styles.profilebodyContainer}>
                    <div className={styles.profileheader}>
                        <h2>Shipping Address</h2>
                        <button className={styles.savechanges} onClick={openAddShipPopup}>Add New Addres</button>
                        {isAddShipPopupOpen && <AddVendorShipping onClose={closeAddShipPopup} id={id} />}
                    </div>
                    <div className={styles.profilebodyContent}>
                        <div className={styles.address_container}>
                            <div className={styles.address_box}>
                                <div className={styles.h3}>Shipping Address</div>
                                <div className={styles.address_deets}>
                                    <p><strong>Dainne Russell</strong></p>
                                    <p>4140 Parker Rd. Allentown, New Mexico 31134</p>
                                    <p><strong>Email:</strong> dainne.russell@gmail.com</p>
                                    <p><strong>Phone:</strong> (671) 555-0110</p>
                                </div>
                                <button className={styles.editbtn} onClick={openEditShipPopup}>Edit Address</button>
                                {isEditShipPopupOpen && <EditVendorBilling onClose={closeEditShipPopup} id={id} />}
                            </div>
                            <div className={styles.address_box}>
                                <div className={styles.h3}>Shipping Address</div>
                                <div className={styles.address_deets}>
                                    <p><strong>Dainne Russell</strong></p>
                                    <p>4140 Parker Rd. Allentown, New Mexico 31134</p>
                                    <p><strong>Email:</strong> dainne.russell@gmail.com</p>
                                    <p><strong>Phone:</strong> (671) 555_0110</p>
                                </div>
                                <button className={styles.editbtn} onClick={openEditShipPopup}>Edit Address</button>
                                {isEditShipPopupOpen && <EditVendorShipping onClose={closeEditShipPopup} id={id} />}
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </>
    );
};

export default VendorProfileBody;
